import { render, staticRenderFns } from "./IconCheckBadge.vue?vue&type=template&id=a1daade6"
import script from "./IconCheckBadge.vue?vue&type=script&lang=js"
export * from "./IconCheckBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports